import React, { useEffect } from "react";
import styles from "./feed.module.scss";
import KoIcon from "@kwapio/icons";

export default function FeedLightbox({ media = [], index = 0, open = false, onClose, setIndex }) {

  const item = media[index];

  const prev = () => setIndex((index - 1 + media.length) % media.length);
  const next = () => setIndex((index + 1) % media.length);

  useEffect(() => {
    if (!open) return; // Hook still runs, but effect will skip logic

    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, index]);

  // 🚨 Important: condition AFTER hooks
  if (!open) return null;

  return (
    <div className={styles.lightboxOverlay}>
      <div className={styles.lightboxHeader}>
        <KoIcon
          name="CloseOutlined"
          width={28}
          height={28}
          className={styles.closeIcon}
          onClick={onClose}
        />
      </div>

      <div className={styles.lightboxContent}>
        {item?.type?.includes("video") ? (
          <video controls src={item.url} className={styles.lightboxMedia} />
        ) : (
          <img src={item.url} alt="" className={styles.lightboxMedia} />
        )}
      </div>

      {media.length > 1 && (
        <>
          <button className={styles.navLeft} onClick={prev}>
            <KoIcon name="ArrowLeftOutlined" width={30} height={30} />
          </button>

          <button className={styles.navRight} onClick={next}>
            <KoIcon name="ArrowRightOutlined" width={30} height={30} />
          </button>
        </>
      )}
    </div>
  );
}
